import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {Platform} from '@angular/cdk/platform';
import {TranslateService} from '@ngx-translate/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';


import {locale as navigationEnglish} from '../app/navigation/i18n/en';
import {locale as navigationTurkish} from '../app/navigation/i18n/bn';
import {AuthService} from './services/auth.service';
import {User} from './dto/user';
import {Module} from './dto/module';
import {Title} from '@angular/platform-browser';
import {getOrganizationLogoName, getOrganizationTheme} from './services/utilities';
import {navigation} from './navigation/navigation';
import {FuseNavigationService} from '../@fuse/components/navigation/navigation.service';
import {FuseSplashScreenService} from '../@fuse/services/splash-screen.service';
import {FuseSidebarService} from '../@fuse/components/sidebar/sidebar.service';
import {FuseConfigService} from '../@fuse/services/config.service';
import {FuseTranslationLoaderService} from '../@fuse/services/translation-loader.service';
import {Organization} from './dto/organization';
import {BaseService} from './services/base.service';
import {AppConfigService} from './services/app-config.service';

declare let $: any;

@Component({
    selector: 'app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

    fuseConfig: any;
    navigation: any;
    loggedUser: User;
    isOrgAdmin = false;
    organizationList: Organization[] = [];

    private _unsubscribeAll: Subject<any>;

    constructor(@Inject(DOCUMENT) private document: any,
                private _fuseConfigService: FuseConfigService,
                private _fuseNavigationService: FuseNavigationService,
                private _fuseSidebarService: FuseSidebarService,
                private _fuseSplashScreenService: FuseSplashScreenService,
                private _fuseTranslationLoaderService: FuseTranslationLoaderService,
                private _translateService: TranslateService,
                private _platform: Platform,
                private _titleService: Title,
                private auth: AuthService,
                private service: BaseService,
                private configService: AppConfigService,
    ) {
        this.loggedUser = this.auth.user;

        if (this.loggedUser) {
            const siteLink = window.location.href;
            this.setTitle(this.loggedUser.Organization.Name);
            this.service.getOrganizationListForLogin({Active: null}).subscribe(pOrganization => {
                this.organizationList = pOrganization;

                this.organizationList.forEach(pOrganizationList => {
                    if (siteLink.includes(pOrganizationList.UrlPath)) {
                        document.getElementById('favicon').href = pOrganizationList.Logo;
                    }
                });
                this._fuseConfigService.setConfig(getOrganizationTheme(this.loggedUser.Organization.Code));
            });
            // document.getElementById('favicon').href = '/assets/images/logos/' + getOrganizationLogoName(this.loggedUser.Organization.Code);
        }

        // <editor-fold desc="Process left sidebar navigation" defaultstate="collapsed">
        let userNavigation = [];
        const tempUserNavigation = [];
        const tempNavReportModule = [];

        if (this.loggedUser) {
            this.isOrgAdmin = this.auth.isOrgAdmin;
            navigation.forEach(pNavItem => {
                if (pNavItem.id === 'superadmin') {
                    if (this.loggedUser.Organization.Code === 'BZM') {
                        pNavItem.isActive = true;
                        userNavigation.push(pNavItem);
                    }
                } else if (pNavItem.id === 'REPORT') {
                    const navReportModule = [];
                    if (pNavItem.children && pNavItem.children.length > 0) {
                        pNavItem.children.forEach(pNavItemReportModule => {
                            pNavItemReportModule.isActive = this._checkNavAccess(pNavItemReportModule.id.replace(/_report/g, ''), this.loggedUser.UserRole.ModuleList, false);
                            if (pNavItemReportModule.isActive) {
                                const navReport = [];
                                if (pNavItemReportModule.children && pNavItemReportModule.children.length > 0) {
                                    pNavItemReportModule.children.forEach(pNavItemReport => {
                                        pNavItemReport.isActive = this._checkNavAccess(pNavItemReport.id, this.loggedUser.UserRole.ModuleList, true);
                                        if (pNavItemReport.isActive) {
                                            if (pNavItemReport.id == 'REPORT_DCR_COUNT_BY_PRODUCT_SEGMENT') {
                                                this.service.getSegmentList({
                                                    Active: true,
                                                    ForProduct: true,
                                                    ResponseFields: 'Id,Active,Name'
                                                }).subscribe(data => {
                                                    if (data.length > 0) {
                                                        data.forEach(pSegment => {
                                                            navReport.push({
                                                                id: 'REPORT_DCR_COUNT_BY_PRODUCT_SEGMENT',
                                                                title: pSegment.Name + ' Wise DCR Count',
                                                                type: 'item',
                                                                url: '/report-dcr/segment-wise-dcr-report/' + pSegment.Id,
                                                                isActive: true
                                                            });
                                                        });
                                                    }
                                                });
                                            } else {
                                                navReport.push(pNavItemReport);
                                            }
                                        }
                                    });
                                }
                                if (navReport.length > 0) {
                                    pNavItemReportModule.children = navReport;
                                    navReportModule.push(pNavItemReportModule);
                                }
                            }
                        });
                    }

                    navReportModule.sort((one, two) =>
                        (one.title > two.title ? 1 : -1));
                    tempNavReportModule.push(navReportModule);

                    if (navReportModule.length > 0) {
                        pNavItem.isActive = true;
                        pNavItem.children = navReportModule;
                        userNavigation.push(pNavItem);
                    }
                } else {
                    pNavItem.isActive = this._checkNavAccess(pNavItem.id, this.loggedUser.UserRole.ModuleList, false);
                    const navChild = [];
                    if (pNavItem.isActive && pNavItem.children && pNavItem.children.length > 0) {
                        pNavItem.children.forEach(pMenuItem => {
                            const navSubMenu = [];

                            pMenuItem.isActive = this._checkNavAccess(pMenuItem.id, this.loggedUser.UserRole.ModuleList, true);
                            if (pMenuItem.isActive) {
                                navChild.push(pMenuItem);
                                switch (pMenuItem.id) {
                                    case 'WEB_MENU_MARKET_STRUCTURE':
                                        if (this.loggedUser.MarketLevelHierarchy && this.loggedUser.MarketLevelHierarchy.length > 0) {
                                            this.loggedUser.MarketLevelHierarchy.forEach(pMarketLevel => {
                                                if (pMarketLevel != null && pMarketLevel.Name != null) {
                                                    navSubMenu.push({
                                                        id: pMarketLevel.Name.toLowerCase(),
                                                        title: pMarketLevel.Name,
                                                        type: 'item',
                                                        url: '/market/list/' + pMarketLevel.Id,
                                                        isActive: true
                                                    });
                                                }
                                            });
                                        }
                                        pMenuItem.children = navSubMenu;
                                        break;

                                    default:
                                        if (pMenuItem.children != null) {
                                            pMenuItem.children.forEach(pSubMenuItem => {
                                                pSubMenuItem.isActive = this._checkNavAccess(pSubMenuItem.id, this.loggedUser.UserRole.ModuleList, true);
                                                if (pSubMenuItem.isActive) {
                                                    navSubMenu.push(pSubMenuItem);
                                                }
                                            });
                                        }
                                        pMenuItem.children = navSubMenu;
                                        break;
                                }

                            } else if (pMenuItem.id === 'CENTRAL_STOCK') {
                                pMenuItem.isActive = this._checkNavAccess(pMenuItem.id, this.loggedUser.UserRole.ModuleList, false);
                                if (pMenuItem.isActive) {
                                    navChild.push(pMenuItem);
                                }
                            } else if (pMenuItem.id === 'DOCTOR_SERVICE') {
                                pMenuItem.isActive = this._checkNavAccess(pMenuItem.id, this.loggedUser.UserRole.ModuleList, false);
                                if (pMenuItem.isActive) {
                                    navChild.push(pMenuItem);
                                }
                            } else if (pMenuItem.id === 'DOCTOR_ORDER') {
                                pMenuItem.isActive = this._checkNavAccess(pMenuItem.id, this.loggedUser.UserRole.ModuleList, false);
                                if (pMenuItem.isActive) {
                                    navChild.push(pMenuItem);
                                }
                            } else if (pMenuItem.id === 'RX_SURVEY') {
                                const children = [];
                                pMenuItem.children.forEach(pMenuItemChild => {
                                    pMenuItemChild.isActive = this._checkNavAccess(pMenuItemChild.id, this.loggedUser.UserRole.ModuleList, true);
                                    if (pMenuItemChild.isActive) {
                                        children.push(pMenuItemChild);
                                    }
                                });
                                pMenuItem.children = children;
                                if (pMenuItem.children.length > 0) {
                                    navChild.push(pMenuItem);
                                }
                            } else if (pMenuItem.id === 'PATIENT') {
                                pMenuItem.isActive = this._checkNavAccess(pMenuItem.id, this.loggedUser.UserRole.ModuleList, false);
                                if (pMenuItem.isActive) {
                                    navChild.push(pMenuItem);
                                }
                            } else if (pMenuItem.id === 'PATIENT') {
                                pMenuItem.isActive = this._checkNavAccess(pMenuItem.id, this.loggedUser.UserRole.ModuleList, false);
                                if (pMenuItem.isActive) {
                                    navChild.push(pMenuItem);
                                }
                            } else {

                                if (pMenuItem.id === 'ADMIN') {
                                    pMenuItem.isActive = this._checkNavAccess(pMenuItem.id, this.loggedUser.UserRole.ModuleList, false);

                                    if (pMenuItem.isActive) {
                                        navChild.push(pMenuItem);

                                        if (this.auth.hasAccess('ADMIN', 'ADMIN_ACCESS')) {
                                            navSubMenu.push({
                                                id: 'ADMIN_ACCESS',
                                                title: 'Settings',
                                                type: 'item',
                                                url: '/admin-settings/' + this.loggedUser.Organization.Id,
                                                isActive: true
                                            });
                                        }
                                        pMenuItem.children = navSubMenu;
                                    }
                                }
                            }
                            if (pMenuItem.isActive) {
                                userNavigation.push(pMenuItem);
                            } else if (pMenuItem.id == 'RX_SURVEY') {
                                if (pMenuItem.children.length > 0) {
                                    userNavigation.push(pMenuItem);
                                }
                            }
                        });
                    }
                    pNavItem.children = navChild;
                }
            });

            let dashboard = null;
            let reports = null;
            if (userNavigation.length > 0 && this.auth.isSuperAdmin) {
                userNavigation = userNavigation.filter(pNavigation => pNavigation.id == 'superadmin');
            }
            userNavigation.forEach(pUserNavigation => {
                if (pUserNavigation.title != 'Dashboard' && pUserNavigation.title != 'Report') {
                    tempUserNavigation.push(pUserNavigation);
                } else if (pUserNavigation.title == 'Dashboard') {
                    dashboard = pUserNavigation;
                } else {
                    reports = pUserNavigation;
                }
            });
            tempUserNavigation.sort((one, two) =>
                (one.title > two.title ? 1 : -1));
            if (dashboard) {
                tempUserNavigation.unshift(dashboard);
            }
            if (reports) {
                tempUserNavigation.push(reports);
            }
        }

        this.navigation = tempUserNavigation;
        // </editor-fold>

        // Register the navigation to the service
        this._fuseNavigationService.register('main', this.navigation);

        // Set the main navigation as our current navigation
        this._fuseNavigationService.setCurrentNavigation('main');

        // Add languages
        this._translateService.addLangs(['en', 'bn']);

        // Set the default language
        this._translateService.setDefaultLang('en');

        // Set the navigation translations
        this._fuseTranslationLoaderService.loadTranslations(navigationEnglish, navigationTurkish);

        // Use a language
        this._translateService.use('en');

        // <editor-fold desc="ngxTranslate Fix" defaultstate="collapsed">
        /**
         * If you are using a language other than the default one, i.e. Turkish in this case,
         * you may encounter an issue where some of the components are not actually being
         * translated when your app first initialized.
         *
         * This is related to ngxTranslate module and below there is a temporary fix while we
         * are moving the multi language implementation over to the Angular's core language
         * service.
         *
         * Set the default language to 'en' and then back to 'tr'.
         * '.use' cannot be used here as ngxTranslate won't switch to a language that's already
         * been selected and there is no way to force it, so we overcome the issue by switching
         * the default language back and forth.
         **/
        /*setTimeout( () => {
         this._translateService.setDefaultLang( 'en' );
         this._translateService.setDefaultLang( 'tr' );
         } );*/
        // </editor-fold>

        // Add is-mobile class to the body if the platform is mobile
        if (this._platform.ANDROID || this._platform.IOS) {
            this.document.body.classList.add('is-mobile');
        }

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }


    ngOnInit(): void {
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(pConfig => {
                this.fuseConfig = pConfig;

                console.log('theme -name: ', pConfig.colorTheme);

                // Boxed
                if (this.fuseConfig.layout.width === 'boxed') {
                    this.document.body.classList.add('boxed');
                } else {
                    this.document.body.classList.remove('boxed');
                }

                // Color theme - Use normal for loop for IE11 compatibility
                for (let i = 0; i < this.document.body.classList.length; i++) {
                    const className = this.document.body.classList[i];

                    if (className.startsWith('theme-')) {
                        this.document.body.classList.remove(className);
                    }
                }

                this.document.body.classList.add(this.fuseConfig.colorTheme);
            });
        this.loadGoogleMapsApi();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    toggleSidebarOpen(pKey): void {
        this._fuseSidebarService.getSidebar(pKey).toggleOpen();
    }

    setTitle(newTitle: string): void {
        this._titleService.setTitle(newTitle);
    }

    loadGoogleMapsApi(): void {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.configService.mapApiKey}`;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
    }

    _checkNavAccess(pKey: string, pUserModules: Module[], pIsChildren: boolean): boolean {
        const keys = pKey.toUpperCase().split(',').map(key => key.trim());
        if (keys.includes('DASHBOARD')) {
            return true;
        }

        let accessible = false;

        pUserModules.forEach(pModule => {
            if (this.isOrgAdmin || pModule.IsSubscribed === true) {
                if (accessible) {
                    return;
                }
                if (pIsChildren) {
                    pModule.ResourceList.forEach(pResource => {
                        // DON'T use pKey.toUpperCase().contains( pResource.ResourceEnum ) it'll fail for cases like pKey = REPORT_VIEW_ATTENDANCE_REGISTRAR and pResource.ResourceEnum = VIEW_ATTENDANCE
                        if (keys.includes(pResource.Name) && (this.isOrgAdmin || pResource.IsSubscribed === true)) {
                            accessible = true;
                            return;
                        }
                    });
                } else {
                    if (keys.includes(pModule.Name)) {
                        accessible = true;
                        return;
                    }
                }
            }
        });

        return accessible;
    }

    _checkMenuAccess(pKey: string, pUserModules: Module[], pIsChildren: boolean): boolean {
        const keys = pKey.toUpperCase().split(',').map(key => key.trim());
        if (keys.includes('DASHBOARD')) {
            return true;
        }

        let accessible = false;

        pUserModules.forEach(pModule => {
            if (pModule.Name.includes('MENU')) {
                if (this.isOrgAdmin || pModule.IsSubscribed === true) {
                    if (accessible) {
                        return;
                    }
                    if (pIsChildren) {
                        pModule.ResourceList.forEach(pResource => {
                            // DON'T use pKey.toUpperCase().contains( pResource.ResourceEnum ) it'll fail for cases like pKey = REPORT_VIEW_ATTENDANCE_REGISTRAR and pResource.ResourceEnum = VIEW_ATTENDANCE
                            if (keys.includes(pResource.Name) && (this.isOrgAdmin || pResource.IsSubscribed === true)) {
                                accessible = true;
                                return;
                            }
                        });
                    }
                }
            }
        });

        return accessible;
    }
}
